export default {
      id: "Icon--portal-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--portal",
      toString: function () {
        return this.url;
      }
    }